module.exports = __webpack_public_path__ + "static/media/JA Thumbnail.73972c69.png";